import MultiLanTxt from "../../Components/UI/MultiLanTxt/MultiLanTxt";
import extracerForValidations from "../extractors/extracerForValidations";
import getFieldAddressAfterIndex from "../extractors/getFieldAddressAfterIndex";
import ngExtracter from "../extractors/ngExtracter";
import keepValidating from "./keepValidating";
import keepValidatingInSetState from "./keepValidatingInSetState";
import validate from "./validateV2";

const formValidator = ({
  data,
  setFormValidity,
  clickedActionOrder,
  // fieldAccesses,
  localValidationInformation = [],
  fieldNameAddresses,
  fieldAccessesValidations,
  forceLtr,
  isInsertForm,
}) => {
  let formIsValid = true;
  // if (clickedActionOrder) {
  //   const fieldsToCheck = fieldAccesses
  //     .filter(
  //       (item) =>
  //         item.inWhichStateOrderItBecomesNecessary !== null &&
  //         item.inWhichStateOrderItBecomesNecessary <= clickedActionOrder
  //     )
  //     .map((item) => item.fieldName.replace(/ci_/gi, "").split("_")[1]);
  //   console.log("fieldsToCheck", fieldsToCheck);

  //   setFormValidity((ps) => {
  //     const newValidationState = { ...ps };
  //     fieldsToCheck.forEach((field) => {
  //       if (!validate({ data: data[field], type: "mandatory" }).isValid) {
  //         newValidationState[field] = { isValid: false, msg: <MultiLanTxt tid="MANDATORY" /> };
  //       } else {
  //         newValidationState[field] = { isValid: true, msg: "" };
  //       }
  //     });

  //     for (const validInfo of localValidationInformation) {
  //       const validateRes = validate({
  //         data: ngExtracter(data, validInfo.fieldName),
  //         ...validInfo.validityInfos,
  //       });

  //       const keys = validInfo.fieldName.split(".");
  //       const lastKey = keys.pop();
  //       let current = newValidationState;
  //       keys.forEach((key, index) => {
  //         if (Array.isArray(current[key])) {
  //           const arrayIndex = parseInt(keys[index + 1], 10);
  //           current = current[key][arrayIndex];
  //           keys.splice(index + 1, 1);
  //         } else {
  //           current = current[key];
  //         }
  //       });
  //       current[lastKey] = validateRes;
  //     }

  //     return newValidationState;
  //   });

  //   for (const field of fieldsToCheck) {
  //     if (!validate({ data: data[field], type: "mandatory" }).isValid) {
  //       if (formIsValid) formIsValid = false;
  //       break;
  //     }
  //   }
  //   if (formIsValid) {
  //     for (const localValidField of localValidationInformation) {
  //       const validateRes = validate({
  //         data: ngExtracter(data, localValidField.fieldName),
  //         ...localValidField.validityInfos,
  //       });
  //       if (!validateRes.isValid) {
  //         formIsValid = false;
  //         break;
  //       }
  //     }
  //   }
  // } else {

  setFormValidity((ps) => {
    const newFormValidity = JSON.parse(JSON.stringify(ps));
    // const newFormValidity = structuredClone(ps);
    // console.log("ps", ps);
    // console.log("objectobjectobjectobjectobject", newFormValidity);
    for (const eachEntityAccessValidation in fieldAccessesValidations) {
      // eachEntityAccessValidation is the entityName (key in our fieldAccess get request) example : "JobAplly" , "ECIPerson" , "ECICourse" ...
      if (fieldAccessesValidations?.[eachEntityAccessValidation]?.length > 0) {
        for (const eachFieldValidation of fieldAccessesValidations[eachEntityAccessValidation]) {
          // eachFieldValidation is fieldaccess object (each record) example : {fieldName:"ECIPerson_email",validationType:"Email",...}
          // console.log("fieldNameAddresses", fieldNameAddresses);
          // console.log("eachEntityAccessValidation", eachEntityAccessValidation);
          // console.log("eachFieldValidation.fieldName", eachFieldValidation.fieldName);
          // console.log(
          //   "fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName]",
          //   fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName]
          // );
          keepValidatingInSetState({
            newFormValidity,
            data,
            cleanAddressForExtracer:
              fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName],
            validateAttributes: {
              type: eachFieldValidation.validationType,
              forceLtr,
              isOptional: eachFieldValidation.isMandatory === true ? false : true,
              clickedActionOrder,
              inWhichStateOrderItBecomesNecessary: isInsertForm
                ? null
                : eachFieldValidation.inWhichStateOrderItBecomesNecessary,
            },
            qqqq: "qqqq",
          });
        }
      }
    }
    if (localValidationInformation.length > 0) {
      for (const eachFieldValidation of localValidationInformation) {
        keepValidatingInSetState({
          newFormValidity,
          data,
          cleanAddressForExtracer: eachFieldValidation.fieldName,
          validateAttributes: { ...eachFieldValidation.validityInfos, forceLtr },
          qqqq: "qqqq",
        });
      }
    }
    return newFormValidity;
  });

  if (localValidationInformation.length > 0) {
    for (const info of localValidationInformation) {
      const fieldIsValid = keepValidating({
        formIsValid,
        data,
        cleanAddressForExtracer: info.fieldName,
        validateAttributes: { ...info.validityInfos, forceLtr },
        // tttt: "tttt",
      });
      if (fieldIsValid === false) {
        formIsValid = false;
        break;
      }
    }
  }
  if (formIsValid) {
    let shouldBreakFromEntitiesObjectLoop = false;
    for (const eachEntityAccessValidation in fieldAccessesValidations) {
      // eachEntityAccessValidation is the entityName (key in our fieldAccess get request) example : "JobAplly" , "ECIPerson" , "ECICourse" ...
      if (fieldAccessesValidations?.[eachEntityAccessValidation]?.length > 0) {
        for (const eachFieldValidation of fieldAccessesValidations[eachEntityAccessValidation]) {
          // eachFieldValidation is fieldaccess object (each record) example : {fieldName:"ECIPerson_email",validationType:"Email",...}
          // console.log("before error , fieldNameAddresses", fieldNameAddresses);
          // console.log(
          //   "before error , fieldNameAddresses[eachEntityAccessValidation]",
          //   fieldNameAddresses[eachEntityAccessValidation]
          // );
          // console.log(
          //   "ZZZZZZZZZ [eachFieldValidation.fieldName] ZZZZZZZ ",
          //   eachFieldValidation.fieldName
          // );
          // console.log(
          //   "before error , fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName]",
          //   fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName]
          // );
          const fieldIsValid = keepValidating({
            formIsValid,
            data,
            cleanAddressForExtracer:
              fieldNameAddresses[eachEntityAccessValidation]?.[eachFieldValidation.fieldName],
            validateAttributes: {
              type: eachFieldValidation.validationType
                ? eachFieldValidation.validationType
                : eachFieldValidation.isMandatory === true
                  ? "mandatory"
                  : null,
              forceLtr,
              isOptional: eachFieldValidation.isMandatory === true ? false : true,
              clickedActionOrder,
              inWhichStateOrderItBecomesNecessary: isInsertForm
                ? null
                : eachFieldValidation.inWhichStateOrderItBecomesNecessary,
            },
            tttt: "tttt",
          });
          if (fieldIsValid === false) {
            formIsValid = false;
            shouldBreakFromEntitiesObjectLoop = true;
            break;
          }
        }
        if (shouldBreakFromEntitiesObjectLoop) {
          break; // Break outer loop if needed
        }
      }
    }
  }

  // }

  return formIsValid;
};

export default formValidator;
